const getCountryCode = async () => {
  try {
    const response = await fetch('https://api.country.is/');
    const data = await response.json();
    return data.country;
  } catch {
    return "GB"
  }
  
}

export {
  getCountryCode
}